import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LEGAL } from '../../config/legal';

/**
 * Site footer. Every link goes somewhere real: sections of the home page, an email
 * address, or a page. Help Center, FAQ and Pricing pages don't exist yet, so they
 * are not linked.
 */
export function SiteFooter() {
  const { t } = useTranslation();
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>Careumba</h4>
          <p>{t('footer.tagline')}</p>
        </div>
        <div className="footer-section">
          <h4>{t('footer.product')}</h4>
          <ul>
            <li><Link to="/#features">{t('footer.features')}</Link></li>
            <li><Link to="/#download">{t('footer.download')}</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>{t('footer.support')}</h4>
          <ul>
            <li><a href={`mailto:${LEGAL.supportEmail}`}>{t('footer.contactUs')}</a></li>
            <li><Link to="/delete-account">{t('footer.deleteAccount')}</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>{t('footer.legal')}</h4>
          <ul>
            <li><Link to="/privacy">{t('footer.privacy')}</Link></li>
            <li><Link to="/terms">{t('footer.terms')}</Link></li>
            <li><Link to="/impressum">{t('footer.impressum')}</Link></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>{t('footer.copyright')}</p>
      </div>
    </footer>
  );
}
